import React, {
  useState,
  useEffect,
  Fragment,
  useContext,
  useRef,
  Profiler,
} from "react";
import Cookies from "universal-cookie";
import { getMyProfile } from "./api/userApi";
import "./App.css";
import LoadingContext from "./contexts/loading-context";
import UserContext from "./contexts/user-context";
import Footer from "./Footer/Footer";
import Home from "./Home/Home";
import Profile from "./Profile/Profile";
import SignIn from "./SignIn/SignIn";
import GridLoader from "react-spinners/GridLoader";
import { ErrorModal } from "./Shared/ErrorModal";
import ErrorContext from "./contexts/error-context";
import MyNotifications from "./Profile/MyNotifications";
import SignIn2 from "./SignIn/SignIn2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Route, Switch, Redirect, Link } from "react-router-dom";
import NewProfile from "./Profile/NewProfile";

const cookies = new Cookies();

function App() {
  const [whiteScreen, setWhiteScreen] = useState(true); //wtf?? why is it not loading screen lmao

  const [isLoading, setIsLoading] = useState(true);
  const [isError, showErrorModal] = useState(false);

  const [user, setUser] = useState(null);
  const [seller, setSeller] = useState(null);
  const [signInShown, setSignInShown] = useState(false);
  const [signInModalOpen, showSignInModal] = useState(false);

  useEffect(() => {
    checkUserSignedIn();

    return () => {};
  }, []);

  async function checkUserSignedIn() {
    const squishtoken = cookies.get("squishtoken");
    if (squishtoken) {
      console.log("log in");
      await getMyProfile()
        .then(async (res) => {
          if (res.data.success && res.data.data) {
            setUser(res.data.data);
            setIsLoading(false);
            setWhiteScreen(false);
          }
        })
        .catch((e) => {
          setIsLoading(false);
          setWhiteScreen(false);
          showErrorModal(true);
        });
    } else {
      setIsLoading(false);
      setWhiteScreen(false);
      console.log("is not log in");
    }
  }
  async function handleUserSignIn(data) {
    cookies.set("squishtoken", data.token);
    setUser(data.userProfile);
  }

  function handleUserSignOut() {
    cookies.remove("squishtoken");
    setUser(null);
  }
  return !whiteScreen ? (
    <UserContext.Provider
      value={{
        user,
        setUser,
        handleUserSignIn,
        handleUserSignOut,
      }}
    >
      <LoadingContext.Provider value={{ setIsLoading }}>
        <ErrorContext.Provider value={{ showErrorModal }}>
          <div style={{ backgroundColor: user ? "white" : "#eaffea" }}>
            <div className="container">
              <nav
                class="navbar navbar-expand-lg navbar-light sticky-top"
                style={{
                  backgroundColor: user ? "white" : "#eaffea !important",
                }}
              >
                <Link class="navbar-brand" to="/">
                  <img
                    src="/squish-alert-text.png"
                    height="50"
                    class="d-inline-block align-top"
                    alt="SquishAlert logo"
                  />
                </Link>
                <div className="d-flex flex-grow-1 justify-content-end">
                  <a
                    className="nav-link link-secondary"
                    href="https://www.paypal.com/donate?hosted_button_id=6X43CPNT5B9YW"
                    target="_blank"
                    style={{ fontWeight: "bold", textDecoration: "underline" }}
                  >
                    Support us
                  </a>
                  {user && (
                    <div className="d-flex flex-row">
                      <FontAwesomeIcon icon={["fas", "coffee"]} />

                      <Link className="btn btn-outline-secondary" to="/profile">
                        <i className="fas fa-user-cog"></i>
                      </Link>
                    </div>
                  )}
                </div>
              </nav>
              {user ? (
                <Switch>
                  <Route exact path="/" component={MyNotifications} />
                  <Route exact path="/profile" component={NewProfile} />
                </Switch>
              ) : (
                <SignIn2 />
              )}
              <Footer />
              {isLoading && (
                <div className="loading-wrapper">
                  <GridLoader color="green" size={20} loading={isLoading} />
                  <h5>Loading, please wait...</h5>
                </div>
              )}
              <script
                async
                src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6162738270062424"
                crossorigin="anonymous"
              ></script>
              {/* <!-- Test Ad --> */}
              <ins
                class="adsbygoogle"
                style={{ display: "block" }}
                data-ad-client="ca-pub-6162738270062424"
                data-ad-slot="2033936080"
                data-ad-format="auto"
                data-full-width-responsive="true"
              ></ins>
              <script>
                (adsbygoogle = window.adsbygoogle || []).push({});
              </script>
            </div>
          </div>
          <ErrorModal isVisible={isError} setVisible={showErrorModal} />
        </ErrorContext.Provider>
      </LoadingContext.Provider>
    </UserContext.Provider>
  ) : (
    <></>
  );
}

export default App;
